import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFilter } from '../../../interfaces/filter-config';
import { IMineZone } from '../../../interfaces/mine-zone'; // may have to change the interface
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-all-mine',
  templateUrl: './filter-all-mine.component.html',
  styleUrls: ['./filter-all-mine.component.scss'],
})
export class FilterAllMineComponent implements AfterViewInit {
  @Input() public filter: IFilter;

  @Output() public allMinesChanged: EventEmitter<IMineZone[]>;

  public allMine: any[];
  public selectedOption: any;

  constructor(
    private filterHandlerService: FilterHandlerService,
    private cdr: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.allMine = [];
    this.allMinesChanged = new EventEmitter<IMineZone[]>();
  }

  /**
   * App after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      if (!this.filter.uniqueSelection) {
        this.selectedOption = null;
      }
    });
    this.getAllMines();
  }

  /**
   * Function to change selected mine
   *
   * @param $event selected mine
   */
  public changeSelectedOption($event: any): void {
    this.allMinesChanged.emit($event);
    this.selectedOption = Array.isArray($event) ? $event : $event.zoneId;
    const filter = {
      filter_selected: 'filter_allMine',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to get mines by machine type
   *
   * @param machineTypes Incoming machine type
   */
  public getAllMines(): void {
    this.filterHandlerService
      .getAllMine()
      .then((allMines: IMineZone[]) => {
        this.allMine = allMines?.map((item) => {
          return { name: item.name, zoneId: item.zoneId };
        });
      })
      .catch((err) => console.error(err));
  }
}
